export default __webpack_public_path__ + "static/media/detail_mobile_11_5.0b12b885.jpg";